export enum AlertType {
  Success,
  Warning,
  Info,
  Error
}
